import { DynamicFormEntryModel } from "@/app/dynamic-components/dynamic-components.model";
import { RenderItem } from "@/app/Types";
import {SharingModel} from "@/app/models/activity/activity-definition.model";

//#region Definition

export interface DynamicDetailEntry {
  id: string;
  name: string;
  type: string;
  displayMode?: string;
  displayModeRule?: string;
  computedValue?: string;
  metadata: { [key: string]: any };
  rules?: { [key: string]: string };
  children?: DynamicDetailEntry[];
}

export interface DynamicDetailDefinition {
  title: string;
  subtitle: string;
  detailContextData: { [key: string]: any };
  actions: DetailAction[];
  summary: DynamicDetailEntry | null;
  children: DynamicDetailEntry[];
  dialogs: { [key: string]: DynamicDetailEntry };
  shareManagement: {
    canDeleteSharesRule: string;
    canDisplaySharesRule: string;
    canAddSharesRule: string;
    shareRules: SharingModel[]
  }
}

export interface InvolvedPartyDefinition {
  id: string;
  roleId: string;
  contactType: "USER" | "ORGANISATION";
  partyRoleId?: string //roleid for user/org. as this is seperate from the roleId of the party system
}

export interface ExchangeDefinition {
  id: string;
  type: "FREEFILL" | "STEPPER";
  adminRule?: string;
  name: string;
  title: string;
  hideTitle: boolean;
  description: string;
  involvedParties: InvolvedPartyDefinition[];
  steps: ExchangeDefinitionStep[];
}

export interface DetailAction {
  id: string;
  event?: string;
  name: string;
  type: string;
  icon: string;
  enabled: string;
  shown: string;
  metadata?: { [key: string]: any };
}

export interface DetailSteps {
  entries: DetailStep[];
}

// is this one actually being used?? seems deprecated to me...
export interface DetailStep {
  id: string;
  name: string;
  form: string;
  shouldIncludeStep: boolean;
  required: boolean;
  canEditAfterCompletion: boolean;
}

export interface ExchangeDefinitionStep {
  id: string;
  name: string;
  title: string;
  action: string;
  form: RenderItem;
  involvedParty: string;
  freeFormIsBlockingStep?: boolean;
  preActions: any[];
  postActions: any[];
}
//#endregion

//#region Data Model
export interface DynamicDetailModel {
  _embedded: { [key: string]: any };
}
//#endregion

export function dynamicDetailEntryToDefinition(entry: DynamicDetailEntry): any{
  return entry;
}
